import React from 'react';
import classes from './Footer.module.css';
import {Flex, Image} from "antd";
import MyText from "../../../components/UI/Text/MyText";
import {Link} from "react-router-dom";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import {useScroll} from "../../../components/Scroll/Scroll";
import aitu from './aitu-logo-3 1.png';
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
const Footer = () => {
    const scroll = useScroll();

    return (
        <Flex className={classes.mainBlock} id={"contacts"} vertical gap={50}>
            <HorizontalDivider/>
            <Flex align={"center"} justify={"space-around"} gap={50} wrap={"wrap"} style={{width: "100%",maxWidth: 1440, position: "relative"}}>
                <Flex vertical gap={15} align={"flex-start"} justify={"center"}>
                    <Image src={aitu} preview={false} width={200}/>
                </Flex>
                <Flex vertical gap={15} align={"flex-start"} justify={"center"}>
                    <Link to={'#about'} onClick={() => {
                        scroll('about');
                    }} className={classes.hoverText}>
                        <MyText uppercase strong>
                            <IntlMessage id={'homePage.footer.aboutProject'}/>
                        </MyText>
                    </Link>
                    <Link to={'#monitoring'} onClick={() => {
                        scroll('monitoring');
                    }} className={classes.hoverText}>
                        <MyText uppercase strong>
                            <IntlMessage id={'homePage.monitoring'}/>
                        </MyText>
                    </Link>
                </Flex>
                <Flex vertical align={"flex-start"} justify={"center"} gap={20}>
                    <Flex vertical align={"flex-start"} justify={"flex-start"}>
                        <MyText strong>
                            <IntlMessage id={'homePage.contacts'}/>
                        </MyText>
                    </Flex>
                    <Flex vertical align={"flex-start"} justify={"flex-start"} gap={7}>
                        <MyText medium>
                            Tel: +7 747 300 0533
                        </MyText>
                        <MyText medium>
                            Alexandr.Neftissov@astanait.edu.kz
                        </MyText>
                        <MyText medium>
                            <IntlMessage id={'homePage.footer.address'}/>
                        </MyText>
                        <MyText medium>
                            <IntlMessage id={'homePage.footer.time'}/>
                        </MyText>
                    </Flex>

                </Flex>
            </Flex>
        </Flex>
    );
};

export default Footer;